module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var criminal = Util.clone(value); 
    ; __append("\n")
    ;  if (criminal.removed) { 
    ; __append("\n\n<b>УДАЛЁН</b>\n\n")
    ;  } else { 
    ; __append("\n")
    ;  if (Util.isDefined(criminal.type)) { 
    ; __append("\n<div>\n	<b>")
    ; __append(escapeFn( Glonass.CriminalType.title(criminal.type) ))
    ; __append("</b>\n</div>\n")
    ;  } 
    ; __append("\n")
    ;  if (criminal.person) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Person", {value: criminal.person, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n")
    ;  if (criminal.vehicle) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Vehicle", {value: criminal.vehicle, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}